import { Component, Input } from '@angular/core';

@Component({
  selector: 'sm-error',
  templateUrl: './sm-error.component.html',
  styleUrls: ['./sm-error.component.scss']
})
export class SmErrorComponent {
  @Input() control;
  @Input() label = '';
}
